import { z } from 'zod';

/** `?page=` in a list route's search params. Page 1 is left out of the URL. */
export const pageSearch = z.number().int().min(1).optional().catch(undefined);
